<html lang="en">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta http-equiv="x-ua-compatible" content="ie=edge">
  <meta name="author" content="Xmartlabs">
</head>

<body id="terms-and-conditions">
  <ngx-spinner></ngx-spinner>

  <div class="container-fluid">
    <div class="row terms-and-conditions-section ">
      <ng-container *ngIf="isLoading$ | async">
        <div class="progress progress-modal">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
            style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </ng-container>
      <div class="col-xs-12 hed"
        style="background-image:linear-gradient(rgb(30, 148, 250), rgb(45, 222, 255));height: 250px;margin-top: 30px;">

      </div>
      <div class="col-lg-3"></div>
      <div class="col-lg-6  sh-page" style="border-radius: 10px;">
        <img src="assets/img/verified.png" alt="FCH" width="80px" height="80px" style="margin-top: -20px;">
        <div class="row " style="margin-bottom: 30px;">
          <h3>{{ language == 'en'? ReportNameEn : ReportNameAr }}</h3>
        </div>
        <div class="row" style="text-align: justify;">
          <div class="col-lg-3"></div>
          <div class="col-lg-8">
            <div class="form-group">
              <label>{{ language == 'en'? ' Name ':' الاسم ' }} : {{ language == 'en'? VerifyReportModel?.patientNameEn
                : VerifyReportModel?.patientNameAr }} </label>
            </div>
          </div>
          <div class="col-lg-3"></div>
          <div class=" col-lg-8">
            <div class="form-group">
              <label>{{ language == 'en'? ' National ID / Iqama ':' رقم الهوية ' }} : {{
                VerifyReportModel?.patientPassportNo }} </label>
            </div>
          </div>
          <div class="col-lg-3"></div>
          <div class="col-lg-8">
            <div class="form-group">
              <label>{{ language == 'en'? ' Visit Date ':' تاريخ الزيارة ' }} : {{ VerifyReportModel?.visitDate | date
                :'dd/MM/yyyy  hh:mm a' }} </label>
            </div>
          </div>
        </div>
        <div class="row"  *ngIf="ReportName == 'SickLeaveReport'" style="text-align: justify;"> 
          <div class="col-lg-3"></div>
          <div class="col-lg-8">
            <div class="form-group">
              <label>{{ language == 'en'? 'From Date':' بدء الاجازة' }} : {{ VerifyReportModel?.fromDate | date
                :'dd/MM/yyyy' }} </label>
            </div>
          </div>
          <div class="col-lg-3"></div>
          <div class="col-lg-8">
            <div class="form-group">
              <label>{{ language == 'en'? 'To Date':' انتهاء الاجازاة' }} : {{ VerifyReportModel?.toDate | date
                :'dd/MM/yyyy' }} </label>
            </div>
          </div>
          <div class="col-lg-3"></div>
          <div class="col-lg-8">
            <div class="form-group">
              <label>{{ language == 'en'? 'Duration':'مدة الاجازة' }} : {{ VerifyReportModel?.durationNo  }} {{ language == 'en'? 'Days' : 'ايام'}}</label>
            </div>
          </div>
        </div>
        <!-- <button class="btn btn-primary btn-lg" (click)="ViewReport()" style="margin-top: 30px;">{{ language == 'en' ? 'Download report' : 'تحميل التقرير' }}</button>             -->
      </div>
      <div class="col-lg-4"></div>
      <div class="col-lg-4 fot text-center" style="margin: 20px 0px">
      </div>
    </div>
  </div>
</body>

</html>